 import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";

// For production, include a set of commonly used widgets in the main bundle
// the rest will be split into their own chunks
// Do not do this for the ./Overrides folder
 const widgets = IS_PRODUCTION
     ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn)\/.+?\.tsx$/)
     : require.context("./Widgets", true, /\.tsx$/);
// enable hot module reloading for widgets
 const onHotWidgetReplace = addWidgetsFromContext(widgets);
 if (module.hot) {
     module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
 }

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
// const pages = require.context("./Pages", true, /\.tsx$/);
// const onHotPageReplace = addPagesFromContext(pages);
// if (module.hot) {
//     module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
// }

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));


// Load all the extensions to the base widgets. This includes style extensions.
const widgetExtensions = require.context("./WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

const store = require.context("./Store", true);
store.keys().forEach(key => store(key));

import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";

setPreStyleGuideTheme({
    link: {
        defaultProps: {
            typographyProps: {
                weight: "bold",
            },
        },
    },
    typography: {
        fontFamilyImportUrl: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
        body: {
            size: "15px",
            weight: 500,
            fontFamily: "'Roboto', sans-serif",
        },
        headerPrimary: {
            forwardAs: "p",
            size: "24px",
            fontFamily: "'Roboto', sans-serif",
            color: "text.main",
            transform: "uppercase",
        },
        headerSecondary: {
            forwardAs: "p",
            size: "15px",
            fontFamily: "'Roboto', sans-serif",
            transform: "uppercase",
            weight: 500,
        },
        headerTertiary: {
            forwardAs: "p",
            size: "15px",
            fontFamily: "'Roboto', sans-serif",
            color: "text.main",
            transform: "uppercase",
        },
    },
});

setPostStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 1100, 1370],
        maxWidths: [540, 540, 900, 1400, 1600],
    },
});